import React from 'react';
import { Image, View } from 'react-native';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import Label from '../Label';
import ModalContainer from '../ModalContainer';

const MissionBasicInformationPopup = ({ onConfirm, onClose }: { onConfirm: () => void; onClose: () => void }) => {
  const t = useTranslation();
  const theme = useCustomTheme();

  return (
    <ModalContainer buttonText={t('im-ready')} onConfirm={onConfirm} onClose={onClose}>
      <View style={{ flexShrink: 1, alignItems: 'center' }}>
        <Image style={{ width: 116, height: 68, tintColor: theme.isDark ? '#ffffff' : undefined }} source={require('../../../../assets/annoucement.png')} />
        <Label style={{ fontSize: 26, fontWeight: '600', color: theme.text.sea, textAlign: 'center' }}>{t('Attention')}</Label>
        <Label style={{ fontSize: 18, fontWeight: '600', color: theme.text.darkTurquoiseTwo, textAlign: 'center' }}>
          {t('We-need-some-basic-information-before-getting-star')}
        </Label>
        <Label style={{ marginTop: 12, fontSize: 14, textAlign: 'center' }}>{t('Please-complete-your-profile-by-answering-the-foll')}</Label>
      </View>
    </ModalContainer>
  );
};

export default MissionBasicInformationPopup;
